import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { applicationStore } from "src/store/ApplicationStore";
import { observer } from "mobx-react";

const Final = observer(() => {
  const navigate = useNavigate();

  useEffect(() => {
    const inProgressServices = applicationStore.workflowNextServiceResponse?.inprogress_services;

    if (!Array.isArray(inProgressServices) || inProgressServices.length === 0) {
      navigate("/success", { replace: true });
    } else {
      navigate("/processing", { replace: true });
    }
  }, [navigate]);

  return null; // No UI to render
});

export default Final;
